const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export function buildApiUrl(path: string) {
  if (!API_BASE_URL) return path;
  return new URL(path, API_BASE_URL).toString();
}

export async function apiRequest<T>(
  path: string,
  init: RequestInit = {},
  accessToken?: string | null,
): Promise<T> {
  const headers = new Headers(init.headers ?? {});
  const isFormData = init.body instanceof FormData;

  if (!isFormData && init.body && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }

  if (accessToken && !headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${accessToken}`);
  }

  const response = await fetch(buildApiUrl(path), {
    ...init,
    headers,
    credentials: 'include',
  });

  const text = await response.text();
  const data = text ? safeJsonParse(text) : null;

  if (!response.ok) {
    let errorMessage = 'Request failed';

    if (data && typeof data === 'object' && 'error' in data) {
      const error = (data as { error?: any }).error;

      if (typeof error === 'string') {
        errorMessage = error;
      } else if (error && typeof error === 'object') {
        // Handle structured error objects
        errorMessage = error.message || error.code || JSON.stringify(error);
      }
    }

    throw new Error(errorMessage);
  }

  return data as T;
}

function safeJsonParse(payload: string) {
  try {
    return JSON.parse(payload);
  } catch {
    return null;
  }
}
